import React, { useState, useEffect } from 'react';
import ManageExistingSolutions from './ManageExistingSolutions';
import { useAuthentication } from '../../hooks/useAuthentication';
import { useTranslation } from 'react-i18next';
import { showToast } from '../../helpers/showToast';
import * as api from '../../services/apis';

const ManageExistingSolutionsContainer = () => {
  const { t } = useTranslation();
  const [renderSolutions, setRenderSolutions] = useState([]);
  const [originalSolutions, setOriginalSolutions] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  const [loading, setLoading] = useState(false);

  const { logout, userInfo } = useAuthentication();
  const [selectedSolutions, setSelectedSolutions] = useState([]);

  const getSolutions = (taxNumber) => {
    api
      .getRegisteredSolutions(taxNumber)
      .then((resp) => {
        setOriginalSolutions(resp?.data?.productionCertificateResponseList);
        setRenderSolutions(resp?.data?.productionCertificateResponseList);
        setTableLoading(false);
      })
      .catch((err) => {
        if (err?.status === 401) {
          // eslint-disable-next-line no-undef
          logout({ redirect: location.pathname });
        }
        setTableLoading(false);
      });
  };

  const onRevokeClick = async (requestIds, reason, description) => {
    await revokeCertificate(
      requestIds,
      userInfo?.tax_number,
      reason,
      description,
    );
    setSelectedSolutions([]);
  };

  const revokeCertificate = async (
    requestIds,
    taxNumber,
    reason,
    description,
  ) => {
    return new Promise((resolve, reject) => {
      setLoading(true);

      api
        .revokeCertificate(requestIds, taxNumber, reason, description)
        .then((result) => {
          getSolutions(taxNumber);
          getSolutions(userInfo.tax_number);
          if (result.data.overallStatus === 200) {
            showToast({
              data: {
                variant: 'info',
                text: t('revoked_successfully'),
              },
            });
            resolve();
          } else if (result.data.overallStatus === 207) {
            showToast({
              data: {
                variant: 'warning',
                text: t('revocation_warning'),
              },
            });
            resolve();
          } else {
            showToast({
              data: {
                variant: 'error',
                text: t('revocation_failed'),
              },
            });
            reject(new Error('Revoking failed'));
          }
        })
        .catch(() => {
          reject(new Error('Revoking failed'));
          showToast({
            data: {
              variant: 'error',
              text: t('revocation_failed'),
            },
          });
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  useEffect(() => {
    if (userInfo) {
      getSolutions(userInfo.tax_number);
    }
  }, [userInfo]);

  return (
    <ManageExistingSolutions
      solutions={renderSolutions}
      onRevokeClick={onRevokeClick}
      originalSolutions={originalSolutions}
      setRenderSolutions={setRenderSolutions}
      loading={loading}
      tableLoading={tableLoading}
      getSolutions={getSolutions}
      selectedSolutions={selectedSolutions}
      setSelectedSolutions={setSelectedSolutions}
    />
  );
};

export default React.memo(ManageExistingSolutionsContainer);
